import { settingsMileageRatesConstants } from './constants';


const initialState = {
  loading: false,
  data: {},
  recordToEdit: null,
  isEditorActive: false,
}

export function settingsMileageRates(state = initialState, action) {
  switch (action.type) {
    case settingsMileageRatesConstants.GET_SETTINGS_MILEAGE_RATE_REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
      };
    case settingsMileageRatesConstants.GET_SETTINGS_MILEAGE_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case settingsMileageRatesConstants.GET_SETTINGS_MILEAGE_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {},
      };
    case settingsMileageRatesConstants.GET_SETTINGS_MILEAGE_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {},
      };
    case settingsMileageRatesConstants.MILEAGE_RATE_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: [...state.data, action.payload]
      };
    case settingsMileageRatesConstants.MILEAGE_RATE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: state.data.map(record => action.payload.id === record.id ? action.payload : record)
      };
    case settingsMileageRatesConstants.MILEAGE_RATE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: state.data.filter(record=>record.id !== action.payload)
      };
    case settingsMileageRatesConstants.TOGGLE_EDITOR:
      console.log(action.payload);

      return {
        ...state,
        isEditorActive: !state.isEditorActive,
        recordToEdit: action.payload
      };
    default:
      return state
  }
}
